import { Button } from "@mui/material";
import styles from "./AccessDenied.module.scss";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { PAGE_URLS } from "@constants/common";

const AccessDenied: FC = () => {
  const navigate = useNavigate();
  const handleBackToLogin = () => {
    navigate("/", { replace: true });
  };

  return (
    <div className={styles["error-page"]}>
      <div className={styles["error-page__image-container"]}>
        <img src="/images/403-atwork.png" alt="Access Denied" />
      </div>
      <div className={styles["error-page__title"]}>Access Denied</div>
      <div className={styles["error-page__message"]}>
        Contact your Super Admin for further assistance
      </div>
      <div className="access-denied-button">
        <Button type="button" onClick={handleBackToLogin}>
          Back to Login
        </Button>
      </div>
    </div>
  );
};

export default AccessDenied;
